import { render, staticRenderFns } from "./TripInfo.vue?vue&type=template&id=2c77b202&scoped=true&"
import script from "./TripInfo.vue?vue&type=script&lang=js&"
export * from "./TripInfo.vue?vue&type=script&lang=js&"
import style0 from "./TripInfo.vue?vue&type=style&index=0&id=2c77b202&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c77b202",
  null
  
)

export default component.exports